import React from 'react';
import CategoryMenuEditor from './CategoryMenu.editor';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { CategoryMenuSkinnable } from './CategoryMenuSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(CategoryMenuSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const CategoryMenuWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={CategoryMenuSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'editor' : 'preview'}
      editorProps={props}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.CATEGORY_MENU || 'CATEGORY_MENU',
  component: CategoryMenuWrapper,
  editorComponent: CategoryMenuEditor,
  defaultProps: {
    style: {
      padding: '10px'
    },
    componentProps: {
      skin: 'basic',
      menuItems: [],
      showProductCount: false,
      showIcon: false,
      showDescription: false,
      layout: 'list',
      columns: 3,
      emptyMessage: '메뉴가 없습니다.'
    }
  },
  category: 'navigation',
  icon: '📂',
  name: '카테고리 메뉴',
  skinnable: CategoryMenuSkinnable
});

// 컴포넌트 및 타입 내보내기
export { CategoryMenuWrapper as CategoryMenuComponent };
export { default as CategoryMenuEditor } from './CategoryMenu.editor';
export * from './CategoryMenu.types';